var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0499 7.94707C11.0499 7.09083 11.7624 6.75958 12.9136 6.75958C14.819 6.80075 16.6886 7.28453 18.3748 8.17269V3.00401C16.6361 2.32071 14.7817 1.98009 12.9136 2.0009C8.47621 2.0009 5.5 4.32524 5.5 8.20644C5.5 14.2789 13.8386 13.2926 13.8386 15.9101C13.8386 16.9338 12.9636 17.2513 11.7324 17.2513C9.91681 17.2513 7.57185 16.5001 5.7325 15.5001V20.7363C7.62623 21.5602 9.66784 21.9902 11.733 22C16.2936 22 19.4373 19.7469 19.4373 15.7982C19.4373 9.24455 11.0499 10.4152 11.0499 7.94832V7.94707Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/stripe-logo.7ac355351d852495faa3f628aa7205d0.svg";
export { ForwardRef as ReactComponent };